export default {
  'DiscussedTopics.title': 'Most discussed',
  'DiscussedTopics.positive': 'Positive',
  'DiscussedTopics.negative': 'Negative',
  'DiscussedTopics.topics': 'Topics',
  'DiscussedTopics.reviews': 'Reviews',
  'DiscussedTopics.sentiment': 'Sentiment',
}
